import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { vouchersApi, type CreateVoucherInput, type UpdateVoucherInput } from '../api/vouchers.api'

const KEYS = {
  active: ['vouchers', 'active'] as const,
  admin:  ['vouchers', 'admin']  as const,
  one:    (id: string) => ['vouchers', 'one', id] as const,
}

export function useAdminVouchers() {
  return useQuery({ queryKey: KEYS.admin, queryFn: () => vouchersApi.adminList() })
}
export function useVoucher(id?: string) {
  return useQuery({ queryKey: KEYS.one(id ?? '__none__'), queryFn: () => vouchersApi.adminOne(id!), enabled: !!id })
}
export function useCreateVoucher() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (p: CreateVoucherInput) => vouchersApi.adminCreate(p),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['vouchers'] }),
  })
}
export function useUpdateVoucher() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (v: { id: string; input: UpdateVoucherInput }) => vouchersApi.adminUpdate(v.id, v.input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['vouchers'] }),
  })
}
export function useDeleteVoucher() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => vouchersApi.adminDelete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['vouchers'] }),
  })
}
export function useApplyVoucher() {
  return useMutation({
    mutationFn: (v: { code: string; subtotal: number }) => vouchersApi.apply(v.code, v.subtotal),
  })
}
